import React from 'react';

import {Container} from './styles';

import {PedidoDTO} from '../../../dtos/PedidoDTO';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Button} from '../../Interface/Forms/Buttons/Button';
import { useTheme } from 'styled-components/native';

interface Props {
  pedidos: PedidoDTO;
  gnv?: boolean;

  fluxoNovo: boolean;

  localidade: {
    rank: string;
    tipo: string;
    region: string;
    estado: string;
    cidade: string;
  };
}
export function AddCouponDiscount({pedidos, localidade, gnv}: Props) {
  const navigation = useNavigation();
  const route = useRoute();
  const theme = useTheme();

  return (
    <Container>
      <Button
        title="Aplicar cupom de desconto"
        testID="openDiscountScreen"
        size="small"
        variant="outline"
        color={theme.colors.blue}
        onPress={() =>
          navigation.navigate('Discount', {
            pedidos,
            localidade,
            gnv,
            returnTo: route.name,
          })
        }
      />
    </Container>
  );
}
